"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubAccountAPI = void 0;
const Networking_1 = require("../tools/Networking");
class SubAccountAPI {
    constructor(baseUri) {
        this.baseUri = baseUri;
        this.net = new Networking_1.Networking(baseUri);
    }
    initSubAccount(account, keyInfo) {
        return this.net.post('sub/account/init', {
            account,
            type: 'blockchain',
            key_info: keyInfo,
        });
    }
    sendTransaction(tx) {
        return this.net.post('transaction/send', tx);
    }
    subAccountList(params) {
        return this.net.post('sub/account/list', params);
    }
    checkSubAccounts(params) {
        return this.net.post('sub/account/check', params);
    }
    createSubAccounts(params) {
        return this.net.post('sub/account/create', params);
    }
    editSubAccount(params) {
        return this.net.post('sub/account/edit', params);
    }
}
exports.SubAccountAPI = SubAccountAPI;
//# sourceMappingURL=SubAccountAPI.js.map